import React from 'react';
import { Box, Typography } from '@mui/material';
import { HwtButton } from 'components/@common/Buttons/HwtButton';
import { translate } from 'translations/translator';
import ModalsTranslationVariant from 'translations/variants/modals';

export const ActivityGroupActionTitle = ({
  section,
  activityCount,
  handleRemoveAll,
  errorBtnClass,
  ...props
}) => {
  const t = (key: ModalsTranslationVariant) => translate('modals', key);

  return (
    <Box {...props}>
      <Typography variant="h2">
        {section.title} ({activityCount || 0})
      </Typography>
      <HwtButton
        size="small"
        variant="contained"
        color="secondary"
        style={{
          width: '104px',
          height: '37px',
          fontSize: '14px'
        }}
        className={errorBtnClass}
        onClick={handleRemoveAll}
      >
        {t(ModalsTranslationVariant.removeAll)}
      </HwtButton>
    </Box>
  );
};
